import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/lib/store";
import { fetchIndividualPaymentDues } from "./payment-dues.slice";

export function useIndividualPaymentDues() {
  const dispatch = useAppDispatch();
  const { individualPaymentDues, loading, error } = useAppSelector((s) => s.subsPaymentDues);

  useEffect(() => {
    dispatch(fetchIndividualPaymentDues());
  }, [dispatch]);

  const refresh = () => {
    dispatch(fetchIndividualPaymentDues());
  };

  return {
    individualPaymentDues,
    loading,
    error,
    refresh,
  };
}





